import { Link } from 'react-router-dom'

import { controlIcons } from '../../constants/assets'

export type Crumb = {
  label: string
  /** The trailing crumb is the current page and has no destination. */
  path?: string
}

type BreadcrumbProps = {
  items: Crumb[]
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => (
  <nav aria-label="Breadcrumb">
    <ol className="flex h-[20px] items-end gap-[3px] py-px">
      {items.map((crumb, index) => (
        <li key={crumb.label} className="flex items-end gap-[3px]">
          {index > 0 && (
            <img
              alt=""
              aria-hidden
              className="block h-[24px] w-[12px] max-w-none shrink-0"
              src={controlIcons.breadcrumbArrow}
            />
          )}

          {crumb.path ? (
            <Link className="whitespace-nowrap text-dash-muted hover:underline" to={crumb.path}>
              {crumb.label}
            </Link>
          ) : (
            <span aria-current="page" className="whitespace-nowrap text-dash-link">
              {crumb.label}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
)
